import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import classNames from 'classnames';

import { Bullet } from '../icons';
import './FormRadio.scss';

const FormRadio = ({
  name,
  value,
  disabled = false,
  children = '',
  imageSrc,
  imageAlt = '',
  onClick,
  initialValue,
  className = '',
  validate,
  box = false
}) => {
  const inputId = `form-radio--${name}-${value}`;

  return (
    <label
      htmlFor={inputId}
      className={classNames('form-radio', className, {
        'form-radio--disabled': disabled,
        'form-radio--box': box // Added for CSS clarity
      })}
    >
      <Field
        initialValue={initialValue}
        name={name}
        validate={validate}
        component="input"
        type="radio"
        value={value}
        id={inputId}
        onClick={onClick}
        disabled={disabled}
        className={box ? 'form-radio__box' : 'form-radio__hidden'}
      />

      {/* 1. Logic for Radio Visuals: Image vs Bullet vs Box */}
      {imageSrc ? (
        <div className="form-radio__image-container">
          <img
            className="form-radio__image"
            width="2.4rem"
            height="2.4rem"
            src={imageSrc}
            alt={imageAlt}
          />
        </div>
      ) : (
        !box && (
          <>
            <Bullet
              width="2.4rem"
              height="2.4rem"
              className="form-radio__dot"
            />
            <div className="form-radio__styled" />
          </>
        )
      )}

      {/* 2. Caption Styling based on the "box" prop */}
      <span
        className={classNames({
          'form-radio__caption--border': box,
          'form-radio__caption': !box
        })}
      >
        {children}
      </span>
    </label>
  );
};

FormRadio.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  children: PropTypes.node,
  imageSrc: PropTypes.string,
  imageAlt: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
  validate: PropTypes.func,
  box: PropTypes.bool,
  initialValue: PropTypes.any
};

export default FormRadio;
